import { createContentPropTypes } from '../../../helpers/content';

const content = {
	confirm: 'Change payments',
	confirmSinglePayment: 'Change payment',
	reject: 'Cancel transactions',
	title: 'Exceeds daily limit',
	transactionLimitTitle: 'Exceeds transaction limit',
	singularMessage:
		'A payment you’ve set up will take you over your daily payment limit. Please go back and edit or remove a payment on the following day:',
	pluralMessage:
		'A payment you’ve set up will take you over your daily payment limit. Please go back and edit or remove a payment on the following days:',
	editIFTDailyLimitMessage:
		'This payment will take you over your agreed daily payment limit. Please edit, cancel or reschedule this payment for another day.',
	editIFTTransactionLimitMessage:
		'The payment amount exceeds your agreed transaction payment limit. Please edit or cancel this payment.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
